import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import PageHeader from '../components/PageHeader';

const AREAS = [
	{
		region: 'Central Phoenix',
		cities: [
			{ name: 'Phoenix', desc: 'All Phoenix ZIP codes including Ahwatukee, Arcadia, Biltmore, Camelback, North Phoenix, and Central.' },
			{ name: 'Tempe', desc: 'Full-service remodeling for Tempe homeowners — kitchens, bathrooms, flooring, exteriors, and more.' },
		],
	},
	{
		region: 'East Valley',
		cities: [
			{ name: 'Scottsdale', desc: 'Luxury kitchen and bathroom remodels, whole-home renovations, and high-end finishes for Scottsdale properties.' },
			{ name: 'Mesa', desc: 'From entry-level bathroom updates to full kitchen renovations — we serve all of Mesa.' },
			{ name: 'Chandler', desc: 'Reliable, high-quality remodeling contractors for Chandler homeowners. Free in-home estimates.' },
			{ name: 'Gilbert', desc: 'Deck builds, flooring, painting, and full remodels for Gilbert\'s growing residential communities.' },
		],
	},
	{
		region: 'West Valley',
		cities: [
			{ name: 'Glendale', desc: 'Kitchen, bathroom, flooring, and exterior painting services throughout the Glendale, AZ area.' },
			{ name: 'Peoria', desc: 'All-in-one home remodeling services. We serve all of Peoria including Lake Pleasant and Vistancia areas.' },
			{ name: 'Surprise', desc: 'Renovations for Surprise homeowners — from single-room updates to full-home remodels.' },
			{ name: 'Goodyear', desc: 'Growing community, trusted local contractor. We serve all Goodyear neighborhoods.' },
			{ name: 'Avondale', desc: 'Flooring, painting, windows, and full remodels for Avondale-area properties.' },
			{ name: 'Buckeye', desc: 'Home improvement services for Buckeye homeowners. Free estimates, no drive-out fees.' },
		],
	},
];

function ServiceAreas() {
	return (
		<>
			<Helmet>
				<title>Service Areas | A-Z Home Improvement LLC | Phoenix Metro, AZ</title>
				<meta name="description" content="A-Z Home Improvement LLC serves the entire Phoenix metro area including Scottsdale, Tempe, Mesa, Chandler, Gilbert, Glendale, Peoria, Surprise, and Goodyear." />
			</Helmet>
			<PageHeader
				title="Service Areas"
				subtitle="Serving homeowners across the entire Phoenix metropolitan area — Maricopa County and surrounding communities."
			/>

			<section className="section">
				<div className="container" style={{ textAlign: 'center', maxWidth: 680 }}>
					<h2>Phoenix Metro Area Coverage</h2>
					<p className="helper">A-Z Home Improvement LLC is based in Phoenix, Arizona and serves residential and commercial property owners throughout Maricopa County. We do not charge travel fees within our core service area.</p>
				</div>
			</section>

			{AREAS.map(area => (
				<section key={area.region} className="section section-alt">
					<div className="container">
						<h2 style={{ marginBottom: 20 }}>{area.region}</h2>
						<div className="grid">
							{area.cities.map(city => (
								<div key={city.name} className="card" style={{ padding: '20px 18px' }}>
									<h3 style={{ margin: '0 0 6px', fontSize: 17 }}>
										{city.name}, AZ
									</h3>
									<p className="helper" style={{ margin: '0 0 12px', fontSize: 13 }}>{city.desc}</p>
									<ul className="helper" style={{ margin: 0, paddingLeft: 18, fontSize: 13 }}>
										<li>Kitchen remodeling</li>
										<li>Bathroom renovation</li>
										<li>Flooring & tile</li>
										<li>Painting · Windows · Decks</li>
									</ul>
									<Link to="/contact" style={{ display: 'inline-block', marginTop: 12, color: 'var(--brand)', fontWeight: 600, fontSize: 13 }}>
										Free estimate in {city.name} →
									</Link>
								</div>
							))}
						</div>
					</div>
				</section>
			))}

			{/* Outside area note */}
			<section className="section section-light">
				<div className="container" style={{ textAlign: 'center', maxWidth: 600 }}>
					<div style={{ fontSize: 36, marginBottom: 10 }}>📍</div>
					<h2>Don't See Your City?</h2>
					<p className="helper">Our core service area covers all of Maricopa County. For projects in Pinal County, Yavapai County, or other areas, please contact us — we evaluate out-of-area projects on a case-by-case basis and may be able to accommodate you.</p>
					<Link to="/contact" className="btn" style={{ fontSize: 15, padding: '12px 28px', display: 'inline-block', marginTop: 12 }}>Contact Us</Link>
				</div>
			</section>
		</>
	);
}

export default ServiceAreas;
